import type { ReactNode } from "react";
import { Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

type Props = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};

function SubSectionHeading({ children, sx = {} }: Props) {
  return (
    <Typography
      sx={{
        display: "block",
        color: "primary.main",
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "1px",
        textTransform: "uppercase",
        borderTop: 1,
        borderColor: "divider",
        pt: 3,
        mt: 3,
        mb: 2,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default SubSectionHeading;
